import { z } from 'zod';

export const envSchema = z.object({
  VITE_ENV_NAME: z.enum(['development', 'qa', 'staging', 'production']),
  VITE_GIT_SHA: z.string().min(1),
  VITE_NOFLAKE_URL: z.url().optional(),
  VITE_PDP_GRAPHQL_URL: z.url(),
  VITE_ROLLBAR_ACCESS_TOKEN: z.string().min(1),
  VITE_ROLLBAR_ENABLED: z
    .enum(['true', 'false'])
    .transform((val) => val === 'true'),
  VITE_TITAN_URL: z.url(),
});

export type Env = z.infer<typeof envSchema>;

const getEnv = () => {
  // Get all environment variables from Vite
  const envFromVite = {
    VITE_ENV_NAME: import.meta.env.VITE_ENV_NAME,
    VITE_GIT_SHA: import.meta.env.VITE_GIT_SHA ?? 'development',
    VITE_NOFLAKE_URL: import.meta.env.VITE_NOFLAKE_URL,
    VITE_PDP_GRAPHQL_URL: import.meta.env.VITE_PDP_GRAPHQL_URL,
    VITE_ROLLBAR_ACCESS_TOKEN: import.meta.env.VITE_ROLLBAR_ACCESS_TOKEN,
    VITE_ROLLBAR_ENABLED: import.meta.env.VITE_ROLLBAR_ENABLED,
    VITE_TITAN_URL: import.meta.env.VITE_TITAN_URL,
  };

  // Validate the environment variables
  const result = envSchema.safeParse(envFromVite);

  if (!result.success) {
    // eslint-disable-next-line no-console
    console.error(z.prettifyError(result.error));
    throw new Error('Invalid environment variables');
  }

  return result.data;
};

export const env = getEnv();
